<template>
  <div>
    <div class="login-container">
      <div class="login-box">
        <p class="logo">
          <img src="@/assets/img/login_logo.png"
              alt="CCS">
        </p>
        <div class="login">
          <BaseValidInput
              v-model="id"
              v-validate="'required'"
              name="ID"
              placeholder="Id"
              :error-msg="errors.first('ID')"
              @keyup.enter.native="$refs.password.focus()" />
          <BaseValidInput
              ref="password"
              v-model="password"
              v-validate="'required'"
              class="mt20"
              name="Password"
              placeholder="Password"
              :error-msg="errors.first('Password')"
              :show-password="true"
              @keyup.enter.native="onLogin" />
          <div>
            <el-button @click="onLogin">Sign in</el-button>
          </div>
          <div>
            <el-button
                v-if="showSingleSignOnButton"
                @click="onSSOLoginClick">
              Single Sign On
            </el-button>
          </div>
        </div>
      </div>
    </div>
    <div>
      <BaseDialog
          title="認証コード入力"
          :visible.sync="isDisplayMfaInput"
          width="500px"
          :append-to-body="true"
          :show-footer="false"
          :show-close-icon="false"
          :is-press-escape="false">
        <template slot="contents">
          <!-- 表示項目 -->
          <div class="dialog-inner  mfa-message-area">
            認証アプリの6桁のコードを入力してください。
            <div class="dialog-inner mfa-input">
              <BaseValidInput
                  v-model="authcode"
                  v-validate="'required'"
                  name="認証コード"
                  :maxlength="6"
                  placeholder="認証コード"
                  :error-msg="errors.first('認証コード')" />
            </div>
          </div>
          <div class="dialog-bottom center">
            <el-button
                type="primary"
                @click="onMfaInput">
              送信
            </el-button>
          </div>
        </template>
      </BaseDialog>
      <BaseDialog
          title="認証コード登録"
          :visible.sync="isDisplayMfaRegister"
          width="500px"
          :append-to-body="true"
          :show-footer="false"
          :show-close-icon="false"
          :is-press-escape="false">
        <template slot="contents">
          <!-- 表示項目 -->
          <div class="dialog-inner mfa-message-area">
            <div>二段階認証の登録を行います。</div>
            <div>認証アプリでQRコードを読みとり、表示される認証コードを入力してください。</div>
            <div style="text-align:center">
              <img ref="image"
                  class="image"
                  :src="qrcode"
              >
              <div>シークレットキー：{{ this.secretKey }}</div>
            </div>
            <div class="dialog-inner mfa-input">
              <BaseValidInput
                  v-model="authcode"
                  v-validate="'required'"
                  name="認証コード"
                  :maxlength="6"
                  placeholder="認証コード"
                  :error-msg="errors.first('認証コード')" />
            </div>
            <div>QRコードかシークレットキーを安全な場所に保管してください。</div>
          </div>
          <div class="dialog-bottom center">
            <el-button
                type="primary"
                @click="onMfaRegister">
              送信
            </el-button>
          </div>
        </template>
      </BaseDialog>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import { mapState } from 'vuex'

import common from '@/utils/common'
import message from '@/utils/message'
import auth from '@/utils/auth'
import { v4 as uuid } from 'uuid';
import axios from 'axios'
import * as commonQuery from '@/queries/common'
import * as accountQuery from '@/queries/account'
import * as config from '@/config'
import * as define from '@/define'

import BaseValidInput from '@/components/atoms/BaseValidInput'
import BaseDialog from '@/components/molecules/BaseDialog'

let preTransition = null

export default {
  name: 'Login',
  components: {
    BaseValidInput,
    BaseDialog
  },
  provide () {
    return {
      parentValidator: this.$validator
    }
  },
  data () {
    return {
      id: '',
      password: '',
      tempKey: '',
      isDisplayMfaRegister: false,
      isDisplayMfaInput: false,
      authcode: '',
      secretKey: '',
      qrcode: '',
      redirect: '',
      clientId: '',
      oAuthUrl: ''
    }
  },
  computed: {
    ...mapState({
      accountUuid: (state) => state.accountUuid,
      mfaAuthStatus: (state) => state.mfaAuthStatus,
      urlParams: (state) => state.urlParams
    }),
    showSingleSignOnButton () {
      // 現状login/acnのときのみ表示する
      return location.pathname === '/login/acn'
    }
  },
  beforeRouteEnter (to, from, next) {
    // ログアウト時に自動入力が表示されない場合があるので、更新して表示させる。
    if (from.name != null && from.name !== 'Login') {
      preTransition = from.name
    }
    next()
  },
  async created () {
    // リダイレクト先を設定（以下の順で設定）
    // 1.URLパラメータのredirct
    // 2.localstrageにあるredirect
    // 3.値なし
    if (this.$route.query.redirect) {
      this.redirect = this.$route.query.redirect
    } else {
      this.redirect = localStorage.getItem('redirect')
    }
    localStorage.removeItem('redirect')

    if (preTransition != null) {
      this.$loadingService.show()
      setTimeout(() => {
        window.location.reload(true)
      }, 1)
    }

    // 「/login/acn」からログインしたかどうかのフラグを初期化
    this.$store.dispatch({ type: 'set', states: { 'fromAcnLogin': false } })

    // 認可コードを持っている場合、シングルサインオン処理を実施
    if (this.$route.query.code != null) {
      setTimeout(() => { this.onSSOLogin() }, 300)
    } else {
      // 認可コードがない場合、APIからSSO用の設定を取得
      // （「/acn」以外は現在未対応）
      this.clientId = ''
      this.oAuthUrl = ''
      if (location.pathname === '/login/acn') {
        const response = await axios({ method: 'GET', url: config.AUTH_SSO_CONFIG_URL,
          params: { isACN: 1 } })

        this.clientId = response.data.clientId
        this.oAuthUrl = response.data.OAuthUrl
      } else {
        // 現在未対応
      }
    }
  },
  methods: {
    /**
     * サイトマスタ取得
     */
    getSiteMaster: async function () {
      try {
        let res = await common.postGraphQl(commonQuery.GRAPH_QL_QUERY_SITES, { isMessageControl: true })
        this.$store.dispatch({ type: 'set', states: { 'sites': res.data.data.sites } })
      } catch (error) {
        common.addError(error, { msg: message.MSG_302() })
        throw error
      }
    },
    /**
     * サービスサイトコンフィグ取得
     */
    getServiceSiteConfig: async function () {
      try {
        let res = await common.postGraphQl(commonQuery.GRAPH_QL_QUERY_SERVICE_SITE_CONFIGS, { isMessageControl: true })
        const kvs = {}
        const to = (kv) => {
          return {
            v: [kv.value1, kv.value2, kv.value3],
            label: kv.displayValue,
            abbr: kv.displayAbbr,
            order: kv.displayOrder
          }
        }
        res.data.data.serviceSiteConfigs.forEach((kv) => {
          // サイトコードを最後のキーに追加する
          const site = kv.site
          const siteCode = (site == null ? null : (site.code === '' ? null : site.code))
          let key4 = ''
          if (siteCode) {
            if (kv.key2 === '') { // キーが１つ
              kv.key2 = siteCode
            } else if (kv.key3 === '') { // キーが２つ
              kv.key3 = siteCode
            } else { // キーが３つ
              key4 = siteCode
            }
          }
          if (kv.key2 === '') { // キーが１つ
            kvs[kv.key1] = to(kv)
          } else if (kv.key3 === '') { // キーが２つ
            if (kvs[kv.key1] == null) {
              kvs[kv.key1] = {}
            }
            kvs[kv.key1][kv.key2] = to(kv)
          } else if (key4 === '') { // キーが３つ
            if (kvs[kv.key1] == null) {
              kvs[kv.key1] = { [kv.key2]: {} }
            }
            if (kvs[kv.key1][kv.key2] == null) {
              kvs[kv.key1][kv.key2] = {}
            }
            kvs[kv.key1][kv.key2][kv.key3] = to(kv)
          } else { // キーが４つ
            if (kvs[kv.key1] == null) {
              kvs[kv.key1] = { [kv.key2]: { [kv.key3]: {} } }
            }
            if (kvs[kv.key1][kv.key2] == null) {
              kvs[kv.key1][kv.key2] = { [kv.key3]: {} }
            }
            if (kvs[kv.key1][kv.key2][kv.key3] == null) {
              kvs[kv.key1][kv.key2][kv.key3] = {}
            }
            kvs[kv.key1][kv.key2][kv.key3][key4] = to(kv)
          }
        })
        this.$store.dispatch({ type: 'set', states: { 'serviceSiteConfigs': kvs } })
      } catch (error) {
        common.addError(error, { msg: message.MSG_303() })
        throw error
      }
    },
    /**
     * 検索条件取得
     */
    getSearchConditions: async function () {
      try {
        let res = await common.postGraphQl(commonQuery.GRAPH_QL_QUERY_SEARCH_CONDITIONS, { isMessageControl: true })
        this.$store.dispatch({ type: 'set', states: res.data.data })
      } catch (error) {
        common.addError(error, { msg: message.MSG_307() })
        throw error
      }
    },
    /**
     * アカウント情報取得( 権限ロール タイムゾーン 権限タイプ )
     */
    getPermissionRole: async function () {
      try {
        const query = common.addGraphQlCondition(accountQuery.GRAPH_QL_QUERY_ACCOUNT_DETAIL, { uuid: this.accountUuid })
        const res = await common.postGraphQl(query, { isMessageControl: true })
        const role = _.chain(res)
          .get('data.data.account.permissionRole.permissions')
          .reduce((acc, cur) => {
            _.set(acc, _.get(cur, 'config.key'), cur.value)
            return acc
          }, {})
          .value()
        this.$store.dispatch(
          {
            type: 'set',
            states: {
              role,
              'timeZone': res.data.data.account.timezone || 'Asia/Tokyo',
              'accountType': res.data.data.account.type
            }
          }
        )
      } catch (error) {
        common.addError(error, { msg: message.MSG_304() })
        throw error
      }
    },
    async authOnLogin () {
      try {
        await auth.auth(this.id, this.password, this.tempKey)
      } catch (error) {
        const errorTitle = message.MSG_201()
        let errorMsg = message.MSG_901()
        let canIgnore = false
        if (error.response) {
          switch (error.response.status) {
            case 400:
              errorMsg = message.MSG_202() + '(' + error.response.status + ')'
              canIgnore = true
              break
            case 401:
              errorMsg = message.MSG_203() + '(' + error.response.status + ')'
              canIgnore = true
              break
            case 403:
              errorMsg = message.MSG_205() + '(' + error.response.status + ')'
              canIgnore = true
              break
            default:
              errorMsg = '(' + error.response.status + ')'
          }
        }
        common.addError(error, { msg: errorMsg, title: errorTitle, canIgnore: canIgnore })
        throw error
      }
    },
    /**
     * ログイン処理
     */
    async onLogin () {
      this.$validator.validate().then(async result => {
        if (result) {
          try {
            this.$loadingService.show()
            this.tempKey = common.generateUuid()
            await this.authOnLogin()
            // MFA認証ステータス確認
            await this.checkStatus()
          } catch (error) {
            this.$notify.error({ error: error })
            throw error
          } finally {
            this.$loadingService.close()
          }
        }
      })
    },
    /**
     * ログイン時共通処理
     */
    async login () {
      try {
        await Promise.all([
          this.getSiteMaster(),
          this.getSearchConditions(),
          this.getServiceSiteConfig(),
          this.getPermissionRole(),
          this.deleteOldLocalStorageData()
        ])

        // 検索条件の設定
        this.$store.dispatch('setSearchCondition')
        // 検索条件の選択肢の設定
        this.$store.dispatch('setSearchConditionOptions')

        this.$store.dispatch({
          type: 'set',
          states: {
            'loggedIn': true
          }
        })
        // リダイレクト先が /login か未設定の場合は NoName にルートする。
        const redirect = this.redirect ? this.redirect : '/login'
        if (['/login', './login/acn'].includes(redirect)) {
          this.$router.push('NoName')
        } else {
          this.$router.push(this.redirect)
        }

        // ログアウト時にログインした画面に返ってくるためのフラグを設定
        if (location.pathname === '/login/acn') {
          this.$store.dispatch({ type: 'set', states: { 'fromAcnLogin': true } })
        }
      } catch (error) {
        throw error
      }
    },
    /**
     * Single Sign On ボタンクリック時処理
     */
    async onSSOLoginClick () {
      const redirectURL = location.origin + location.pathname
      const id = uuid() // ランダムな英数字生成

      // ローカルストレージにURLパラメータを退避させておく
      localStorage.setItem('redirect', this.$route.query.redirect)

      // const redirectURL = 'https://panda.cc-s.net/login/acn'
      window.location.href = this.oAuthUrl +
        `?client_id=${this.clientId}` +
        `&redirect_uri=${encodeURIComponent(redirectURL)}` +
        `&scope=user.read%20openid%20profile%20offline_access` +
        `&client-request-id=${id}` +
        `&response_mode=query` +
        `&response_type=code` +
        `&sso_reload=true`
    },
    /**
     * SSO用ログイン処理
     */
    async onSSOLogin () {
      try {
        this.$loadingService.show()
        // 認可コードをリクエストにして、認証APIをコールする
        const redirectURL = location.origin + location.pathname

        try {
          this.tempKey = common.generateUuid()
          await auth.authSSO(this.clientId, redirectURL, this.$route.query.code, this.tempKey, location.pathname === '/login/acn')
        } catch (error) {
          const errorTitle = message.MSG_201()
          let errorMsg = message.MSG_901()
          let canIgnore = false
          if (error.response) {
            switch (error.response.status) {
              case 400:
                errorMsg = message.MSG_202() + '(' + error.response.status + ')'
                canIgnore = true
                break
              case 401:
                errorMsg = message.MSG_206() + '(' + error.response.status + ')'
                canIgnore = true
                break
              default:
                errorMsg = '(' + error.response.status + ')'
            }
          }
          common.addError(error, { msg: errorMsg, title: errorTitle, canIgnore: canIgnore })
          throw error
        }
        // 認証ステータス確認
        await this.checkStatus()
      } catch (error) {
        this.$notify.error({ error: error })
        throw error
      } finally {
        // URLのパラメータを削除する
        const url = new URL(window.location.href)
        const params = url.searchParams
        params.delete('code')
        params.delete('session_state')
        history.replaceState('', '', url.pathname)
        this.$loadingService.close()
      }
    },
    /**
     * 有効期限をすぎたローカルストレージのデータを削除する
     * @returns values アカウントごとに一意な、ローカルストレージに保存する際のキーの値.
     */
    deleteOldLocalStorageData () {
      const uniqueKey = common.getUserUniqueKey()
      Object.keys(localStorage).forEach((localStorageKey) => {
        try {
          // 自身のデータ以外のデータを対象とする
          if (localStorageKey.indexOf(uniqueKey) !== -1) {
            return
          }

          const jsonObj = localStorage.getItem(localStorageKey)
          const jsObj = JSON.parse(jsonObj)
          // 有効期限項目がある かつ 有効期限を過ぎている場合、ローカルストレージから削除
          if (jsObj['LocalStorageExpiration']) {
            const expirationDate = jsObj['LocalStorageExpiration']
            if (expirationDate < Date.now()) {
              localStorage.removeItem(localStorageKey)
            }
          }
        } catch (exception) {}
      })
    },
    /**
     * 送信ボタン押下(入力)
     */
    async onMfaInput () {
      this.$validator.validate().then(async result => {
        if (result) {
          try {
            this.$loadingService.show()
            const url = config.AUTH_MFA_GA + 'token'
            const method = 'post'
            const data = {
              key: this.tempKey,
              authcode: this.authcode,
              cookie: config.COOKIE
            }
            // 認証コード照合API
            const res = await common.apiAxios(url, { method: method, data: data })
            // トークン保存（更新）
            const payload = JSON.parse(window.atob(res.data.token.split('.')[1]))
            this.$store.dispatch({
              type: 'set',
              states: {
                'token': res.data.token,
                'mfaAuthStatus': payload.mfa
              }
            })
            this.isDisplayMfaInput = false
            // 認証ステータス確認
            await this.checkStatus()
          } catch (error) {
            const errorTitle = message.MSG_201()
            let errorMsg = message.MSG_901()
            let canIgnore = false
            if (error.response) {
              switch (error.response.status) {
                case 400:
                  errorMsg = message.MSG_202() + '(' + error.response.status + ')'
                  canIgnore = true
                  break
                case 401:
                  errorMsg = '認証コードを確認してください。' + '(' + error.response.status + ')'
                  canIgnore = true
                  break
                default:
                  errorMsg = '(' + error.response.status + ')'
              }
            }
            this.authcode = ''
            this.$validator.reset()
            common.addError(error, { msg: errorMsg, title: errorTitle, canIgnore: canIgnore })
            this.$notify.error({ error: error })
            throw error
          } finally {
            this.$loadingService.close()
          }
        }
      })
    },
    /**
     * 送信ボタン押下（登録）
     */
    async onMfaRegister () {
      this.$validator.validate().then(async result => {
        if (result) {
          try {
            this.$loadingService.show()
            const url = config.AUTH_MFA_GA + 'secret'
            const method = 'put'
            const data = {
              key: this.tempKey,
              authcode: this.authcode,
              cookie: config.COOKIE
            }
            // シークレットキー登録API
            const res = await common.apiAxios(url, { method: method, data: data })
            this.$notify.success('設定が完了しました。')
            this.isDisplayMfaRegister = false
            const payload = JSON.parse(window.atob(res.data.token.split('.')[1]))
            this.$store.dispatch({
              type: 'set',
              states: {
                'token': res.data.token,
                'refreshToken': res.data.refreshToken,
                'tokenExp': payload.exp,
                'mfaAuthStatus': payload.mfa
              }
            })

            // 認証ステータス確認
            await this.checkStatus()
          } catch (error) {
            const errorTitle = message.MSG_201()
            let errorMsg = message.MSG_901()
            let canIgnore = false
            if (error.response) {
              switch (error.response.status) {
                case 400:
                  errorMsg = message.MSG_202() + '(' + error.response.status + ')'
                  canIgnore = true
                  break
                case 401:
                  errorMsg = '認証コードを確認してください。' + '(' + error.response.status + ')'
                  canIgnore = true
                  break
                default:
                  errorMsg = '(' + error.response.status + ')'
              }
            }
            this.authcode = ''
            this.$validator.reset()
            common.addError(error, { msg: errorMsg, title: errorTitle, canIgnore: canIgnore })
            this.$notify.error({ error: error })
            throw error
          } finally {
            this.$loadingService.close()
          }
        }
      })
    },
    /**
     * MFA認証ステータス確認
     */
    async checkStatus () {
      // トークン確認
      switch (this.mfaAuthStatus) {
        case define.AUTH_MFA_STATUS.UNREGISTERED:    // MFA有効-未登録
          // シークレットキー取得
          await this.getSecretKey()
          // 認証コード登録
          this.isDisplayMfaRegister = true
          this.authcode = ''
          this.$validator.reset()
          break
        case define.AUTH_MFA_STATUS.UNAUTHENTICATED: // MFA有効-未認証
          // 認証コード入力
          this.isDisplayMfaInput = true
          this.authcode = ''
          this.$validator.reset()
          break
        case define.AUTH_MFA_STATUS.AUTHENTICATED:   // MFA有効-認証済、
        case define.AUTH_MFA_STATUS.INVALID:         // MFA認証無効
          // 処理続行、画面遷移
          await this.login()
          break
        default: // 存在しない
          // 処理続行、画面遷移
          await this.login()
      }
    },
    /**
     * シークレットキー取得
     */
    async getSecretKey () {
      const url = config.AUTH_MFA_GA + 'secret'
      const method = 'post'
      const data = {
        cookie: config.COOKIE
      }
      // シークレットキー発行API
      const res = await common.apiAxios(url, { method: method, data: data })
      // シークレットキー
      this.secretKey = res.data.secretKey
      // QRコード
      // DataUrl 例:'data:image/png;base64,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'
      this.qrcode = res.data.qrcode
    }
  }
}
</script>
